<template>
  <div v-if="product == 89 || product === 90" class="loading-container"
    :style="{ backgroundImage: 'url(' + bgc[0] + ')' }">
  </div>
  <div v-else-if="product == 91 || product === 92" class="loading-container"
    :style="{ backgroundImage: 'url(' + bgc[1] + ')' }">
  </div>
  <div v-else-if="product == -1" style="text-align: center;margin-top: 15px;">查询产品信息中,请等待....</div>
  <div class="loading-container" v-else>
    <div>
      <img src="../../assets/img/img_logo.png" />
      <van-progress :percentage="percentage" :show-pivot="false" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '../../store'
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
import { Progress } from 'vant'
import request from '../../util/xc-request'
import Config from '@/config/config'

Vue.use(Toast).use(Progress)
// TODO 需要优化扫码初始化体验，等所有信息都加载完成之后再跳转到抽奖页面

export default {
  name: 'QrcodeIndex',
  data() {
    return {
      serial: this.$route.params.serial,
      percentage: 0,
      interval: null,
      hasScan: false,
      product: -1,
      bgc: [
        // 背景图片
        require('../../assets/img/xiangyun/bg-index.jpg'),
        require('../../assets/img/qingyun/bg-index.jpg')
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'location', 'qrcode'])
  },
  watch: {
    location: function(value) {
      if (Object.keys(value).length && !this.hasScan) {
        this.handleScanWithAuthCheck()
      }
    }
  },
  created() {
    const that = this
    this.interval = setInterval(() => {
      this.percentage += 1
    }, 10)
    setTimeout(() => {
      clearInterval(this.interval)
      that.init()
    }, 1000)
  },
  methods: {
    /**
     * 页面跳转
     */
    jump() {
      // var path = '/award'
      var path = this.qrcode.activity_url ? this.qrcode.activity_url : '/award'
      if (!this.userInfo.mobile) {
        Toast('请先绑定手机号')
        return this.$router.replace({
          path: '/user/phone/bind',
          query: { serial: this.serial }
        })
      }
      if (
        this.product === 89 ||
        this.product === 90 ||
        this.product === 91 ||
        this.product === 92
      ) {
        setTimeout(() => {
          this.$router.replace({ path: path, query: { serial: this.serial, productId: this.qrcode.product.id }})
        }, 2000)
      } else {
        this.$router.replace({ path: path, query: { serial: this.serial, productId: this.qrcode.product.id }})
      }
    },
    /**
     * 页面初始化
     */
    init() {
      // 初始化时也调用统一的扫码处理方法
      if (store.state.location && Object.keys(store.state.location).length && !this.hasScan) {
        this.handleScanWithAuthCheck()
      } else {
        Toast('未获取到位置信息！')
      }
    },
    // 判断星辰用户是否存在
    checkXcUser(callback) {
      var path = '/user/channel/info'
      var params = {
        openid: this.userInfo.openid
      }
      request(path, params, function(err, res) {
        if (!err) {
          if (!res.code) {
            // 星辰用户存在
            return callback(true)
          } else {
            // 不存在
            return callback(false)
          }
        }
      })
    },
    // 星辰授权回调
    xcRedirectUrl(callback) {
      var path = '/user/channel/auth/jumpUrl'
      var currentUrl = Config.baseUrl + '/' + this.serial
      var params = {
        redirectUrl: currentUrl
      }
      request(path, params, function(err, res) {
        console.log(res)
        if (!err) {
          if (!res.code) {
            return callback(null, res.data)
          } else {
            return callback(res)
          }
        }
      })
    },
    // 增加星辰积分
    addXcCredit(amount, callback) {
      var path = '/user/fund/change'
      var remark = '消费者扫码获得' + amount + '积分'
      if (this.qrcode) {
        remark = this.qrcode.product.name + '扫码获得' + amount + '积分'
      }
      var params = {
        openid: this.userInfo.openid,
        amount: amount,
        remark: remark
      }
      request(path, params, function(err, res) {
        console.log(res)
        if (!err) {
          if (!res.code) {
            return callback(null)
          } else {
            return callback(res)
          }
        }
      })
    },
    // 跳转星辰积分商城首页
    getXcMobile(callback) {
      var path = '/mall/basic/info/mobileUrl'
      var params = {}
      request(path, params, function(err, res) {
        console.log(res)
        if (!err) {
          if (!res.code) {
            return callback(null, res.data)
          } else {
            return callback(res)
          }
        }
      })
    },

    // 统一的扫码授权检查方法
    handleScanWithAuthCheck() {
      // 检查是否已授权登录，如果没有且URL中有code，等待授权完成
      if (!store.state.token && this.$route.query.code) {
        Toast.loading('授权中，请稍后...')
        // 等待授权完成，1秒后重试
        setTimeout(() => {
          this.handleScanWithAuthCheck()
        }, 1000)
        return
      }

      // 确认已登录后才执行扫码
      if (store.state.token) {
        var that = this
        this.hasScan = true
        const payload = { serial: this.serial }
        store
          .dispatch('scanQrcode', payload)
          .then(() => {
            this.product = this.qrcode.product.id
            if (
              that.qrcode &&
              that.qrcode.scan_count === 1 &&
              that.qrcode.credit
            ) {
              var msg = '成功增加' + that.qrcode.credit + '积分'
              Toast(msg)
              that.jump()
            } else if (that.qrcode && that.qrcode.scan_count > 1) {
              Toast('该瓶酒的积分已领取过')
              that.jump()
            } else {
              that.jump()
            }
          })
          .catch((err) => {
            this.$router.replace({
              name: 'QrcodeError',
              params: { errMsg: err.message }
            })
          })
      } else {
        // 未登录且没有授权code，跳转到错误页面
        this.$router.replace({
          name: 'QrcodeError',
          params: { errMsg: '请先登录' }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.loading-container {
  width: 100%;
  height: 100%;
  // background-image: url('../../assets/img/background3.png');
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;

  img {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 160px;
    left: 150px;
  }
}
</style>
<style lang="scss">
.loading-container {
  .van-progress {
    position: absolute;
    width: 75px;
    height: 2px;
    top: 265px;
    left: 150px;
    background: #b8b8b8;

    .van-progress__portion {
      background: #5e5ef6 !important;
    }
  }
}

.animate__animated.animate__bounceOut {
  --animate-duration: 5s;
}
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/index.vue